import { Flex, Space, Typography } from 'antd';
import React from 'react';
import { HYPHEN } from '../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;

const DefaultInfoWindowContent = ({ infoWindow, className = '' }) => {
  return (
    <Flex
      vertical
      gap={10}
      id={infoWindow?.key}
      style={{ maxWidth: '180px' }}
      className={className}
    >
      <Space
        style={{
          backgroundColor: infoWindow?.title?.bgColor || '#418BD6',
          padding: '4px',
          justifyContent: 'center',
          textAlign: 'center',
        }}
        className="full-width"
      >
        <Text
          strong
          style={{
            fontSize: '0.75rem',
            color: '#FFFFFF',
          }}
        >
          {infoWindow?.title?.text}
        </Text>
      </Space>
      {Object.keys(infoWindow?.content)?.map(key => (
        <Text key={key} style={{ fontSize: '0.75rem', color: '#000000' }}>
          {key?.split('_')?.join(' ')}:{' '}
          <b>{infoWindow?.content[key] || HYPHEN}</b>
        </Text>
      ))}
      {infoWindow?.children}
    </Flex>
  );
};

DefaultInfoWindowContent.propTypes = {
  infoWindow: PropTypes.object,
  className: PropTypes.string,
};

export default React.memo(DefaultInfoWindowContent);
